// extracted by mini-css-extract-plugin
export default {"like":"_2gReT","not-clickable":"_2Ui1H","notClickable":"_2Ui1H","likebutton":"_3ReLk","likes":"_3-rNS"};